import { createComponent } from '@carvana/merch-components';
import React, { forwardRef } from 'react';

type OwnProps = React.PropsWithoutRef<React.SVGProps<SVGSVGElement>>;

const SearchErrorIcon = createComponent<OwnProps>('svg', {
  className: 'u:text-blue-6'
});

export default forwardRef<SVGSVGElement, OwnProps>((props, ref) => (
  <SearchErrorIcon
    width="57"
    height="56"
    viewBox="0 0 57 56"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.3763 46.7507C31.0568 46.7507 36.2315 44.5856 40.1203 41.0355L52.7918 53.7074C53.1823 54.0979 53.8155 54.0979 54.206 53.7074C54.5966 53.3169 54.5966 52.6837 54.2061 52.2932L41.5346 39.6214C45.0858 35.7324 47.2517 30.5568 47.2517 24.8753C47.2517 12.7939 37.4577 3 25.3763 3C13.2949 3 3.50098 12.7939 3.50098 24.8753C3.50098 36.9568 13.2949 46.7507 25.3763 46.7507ZM25.3763 44.7507C36.3532 44.7507 45.2517 35.8522 45.2517 24.8753C45.2517 13.8985 36.3532 5 25.3763 5C14.3995 5 5.50098 13.8985 5.50098 24.8753C5.50098 35.8522 14.3995 44.7507 25.3763 44.7507Z"
      fill="#106BC7"
    />
    <path
      d="M18.207 16.2929C17.8165 15.9024 17.1833 15.9024 16.7928 16.2929C16.4023 16.6834 16.4023 17.3166 16.7928 17.7071L24.0857 25L16.7928 32.2929C16.4023 32.6834 16.4023 33.3166 16.7928 33.7071C17.1833 34.0976 17.8165 34.0976 18.207 33.7071L25.4999 26.4142L32.7928 33.7071C33.1833 34.0976 33.8165 34.0976 34.207 33.7071C34.5975 33.3166 34.5975 32.6834 34.207 32.2929L26.9141 25L34.207 17.7071C34.5975 17.3166 34.5975 16.6834 34.207 16.2929C33.8165 15.9024 33.1833 15.9024 32.7928 16.2929L25.4999 23.5858L18.207 16.2929Z"
      fill="#106BC7"
    />
  </SearchErrorIcon>
));
